import FilterButtonGroup from "components/FilterButtonGroup";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import { labelFromCarrosserievorm } from "helpers/carrosserievorm";

export const CarrosserievormFilter = ({ condensed }) => {
    const filter = useFilter("carrosserievorm");
    const count = useCount("carrosserievorm");
    const [value, , onChange] = useField("carrosserievormen");

    const options = filter.map((o) => ({
        id: o,
        displayName: labelFromCarrosserievorm(o) || o.toLowerCase(),
        aantal: count?.[o] || 0,
        naam: labelFromCarrosserievorm(o) || o.toLowerCase()
    }));

    return (
        <FilterButtonGroup
            filterId="filter-carrosserievorm"
            datalayerKey="carrosserievorm"
            options={options}
            value={value}
            handleChange={(_, selection) => onChange(selection)}
            columns={condensed ? 2 : 6}
            dataTestId="filter-carrosserievorm"
            scale={0.5}
        />
    );
};
